import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=7bf352ac&scoped=true&"
import script from "./EditTaskModal.vue?vue&type=script&lang=js&"
export * from "./EditTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTaskModal.vue?vue&type=style&index=0&id=7bf352ac&lang=scss&scoped=true&"
import style1 from "./EditTaskModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf352ac",
  null
  
)

export default component.exports